import * as api from '../resources/app-version.api';
import ationTypes from './app-version.action-types';

export const fetchBeAppVersionRequest = () => ({
  type: ationTypes.FETCH_BE_APP_VERSION_REQUEST,
});

export const fetchBeAppVersionSuccess = (version) => ({
  type: ationTypes.FETCH_BE_APP_VERSION_SUCCESS,
  version,
});

export const fetchBeAppVersionFailure = () => ({
  type: ationTypes.FETCH_BE_APP_VERSION_FAILURE,
});

export const fetchBeAppVersion = () => async (dispatch) => {
  try {
    dispatch(fetchBeAppVersionRequest());
    const version = await api.fetchBeAppVersion();
    dispatch(fetchBeAppVersionSuccess(version));
  } catch (error) {
    console.error('FETCH_BE_APP_VERSION', error);
    dispatch(fetchBeAppVersionFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-app-version/actions/app-version.actions.js